<template>
  <div class="slider-dog a-vg-header--main-slider">
    <div class="slides-container">
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackpot-fall-local
            v-if="isLocalSliderActive()"
            :ticketLocation="ticketLocation"
            :jackpotAmount="jackpotAmount"
            :ticketNo="ticketNo"
            :currency="currency" />
        </transition>
      </div>
      <div class="wrapper">
        <transition name="slide">
          <vdog-jackpot-fall-super
              v-if="isSuperSliderActive()"
              :ticketLocation="ticketLocation"
              :jackpotAmount="jackpotAmount"
              :ticketNo="ticketNo"
              :currency="currency" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import VDogJackpotsFallLocal from '@/components/grayhound/slides/VDogJackpotsFallLocalSlide.vue'
import VDogJackpotsFallSuper from '@/components/grayhound/slides/VDogJackpotsFallSuperSlide.vue'

export default {
  components: {
    'vdog-jackpot-fall-local': VDogJackpotsFallLocal,
    'vdog-jackpot-fall-super': VDogJackpotsFallSuper
  },
  props: {
    showSlider: {
      type: String,
      required: true
    },
    ticketLocation: {
      type: String,
      required: true
    },
    jackpotAmount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    ticketNo: {
      type: String,
      required: true
    }
  },
  methods: {
    isLocalSliderActive () {
      return this.showSlider === 'Local'
    },
    isSuperSliderActive () {
      return this.showSlider === 'Super'
    }
  }
}

</script>
